<template>
  <component :class="className" :is="tag">
    <a :href="url" target="_blank" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <span v-if="isDesktop">{{ index + 1 }}</span>
      <span v-else>{{ name }}</span>
    </a>
    <ElementTooltip v-if="isDesktop" :text="name" :active="showTooltip" />
  </component>
</template>

<script>
import ElementTooltip from '@elements/ElementTooltip'
import { mapGetters } from 'vuex'

export default {
  name: 'CardDocumentAnnex',
  props: {
    tag: {
      type: String,
      required: false,
      default: 'div'
    },
    index: {
      type: Number,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  components: {
    ElementTooltip
  },
  data () {
    return {
      showTooltip: false
    }
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice'
    }),
    className () {
      return 'card-document-annex'
    },
    isDesktop () {
      return this.device === 'desktop'
    }
  },
  methods: {
    handleMouseEnter () {
      this.showTooltip = true
    },
    handleMouseLeave () {
      this.showTooltip = false
    }
  }
}
</script>

<style lang="scss">
  .card-document-annex{
    a{
      word-wrap: break-word;
    }
  }
</style>
